import React from "react";
import { Link } from "react-router-dom";
import Image from "../Image";
import { FormatPrice } from "../Util";
import defaultImg from "../../assets/default-image.png";
import { trans } from "../Lang";

class CourseItem extends React.Component {
  render() {
    let data = this.props.data;
    let className = this.props.className;
    let progress = data.progress;

    return (
      <Link
        to={`/course/${data.slug}`}
        className={className || "bg-white product-card"}
      >
        <div style={{ minWidth: this.props.minWidth || "auto" }}>
          <Image src={data.thumbnail || defaultImg} className="image" />
          <div className="content">
            <div>{data.code}</div>
            <div className="title" style={{ paddingTop: "8px" }}>
              {data.title}
            </div>
            {/*}<div className="font-grey mb-s">{data.categories && data.categories.map(o => o["name"]).join(", ")}</div>*/}
            {/* <span className="course-card-instructor">{data.instructor}</span> */}
            {/*data.enrolled && <span className="font-orange"><br/><br/>{trans.enrolled}</span>*/}
            {/* {data.progress == undefined ? (
              <div className="price">
                {data.price ? FormatPrice(data.price) : trans.free}
              </div>
            ) : null} */}
          </div>

          {data.progress !== undefined ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                columnGap: "14px",
                padding: "8px 14px",
              }}
            >
              <div className="progress">
                <div
                  className="determinate"
                  style={{ width: `${data.progress || 0}%` }}
                />
              </div>
              <div>{data.progress || 0}%</div>
            </div>
          ) : null}
        </div>
      </Link>
    );
  }
}

export default CourseItem;



// WEBPACK FOOTER //
// ./src/components/common/CourseItem.js